module.exports = __webpack_public_path__ + "static/media/success-bg-stars.ed17b259.png";